'use strict';

module.exports = ['Active', 'Pending', 'Suspended', 'Removed', 'Inactive'];